// import { faClose } from "@fortawesome/pro-light-svg-icons";
import { faClose } from "@fortawesome/pro-regular-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import Typography from "../Typography";
import { useEffect, useId } from "react";

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;

  display: ${(props) => (props.visible ? "flex" : "none")};
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;

  width: 100%;
  height: 100%;

  background-color: rgba(8, 7, 7, 0.6);
`;

const ModalWrapper = styled.div`
  margin-top: 20vh;
  position: relative;
  width: auto;
  pointer-events: none;
`;

const ModalContent = styled.div`
  border-radius: 5px;
  background-color: #ffffff;
  border: 1 px solid #000;
  pointer-events: auto;
  padding: 16px;
  min-width: 415px;
`;

// A real button so it can be tabbed to and activated with Enter/Space; it was
// a div with an onClick, which no keyboard user could reach.
const ModalDismiss = styled.button`
  --size: 30px;
  display: block;
  padding: 5px;
  border: none;
  background: none;
  color: inherit;
  text-align: center;
  pointer-events: auto;
  cursor: pointer;
  color: #000;
  height: var(--size);
  width: var(--size);

  :hover {
    border-radius: 50%;
    background-color: #f5f2fc;
  }
`;

const DismissIcon = styled(FontAwesomeIcon)`
  display: block;
  width: 100%;
  height: 100%;
`;

// `onEscape` exists for hosts that treat the key differently from a click —
// the analytics viewer lets a Sigma embed keep Escape while it holds focus.
// Left unset, Escape dismisses as it always has.
const Modal = ({
  visible,
  dismiss,
  onEscape,
  title,
  style = {},
  dataTest,
  className,
  children,
}) => {
  const titleId = useId();

  useEffect(() => {
    const handleEscapePress = (event) => {
      if (event.key === "Escape") {
        (onEscape ?? dismiss)();
      }
    };

    document.addEventListener("keydown", handleEscapePress, false);

    return () =>
      document.removeEventListener("keydown", handleEscapePress, false);
  }, [dismiss, onEscape]);

  return (
    <ModalBackground visible={visible} onClick={dismiss} className={className}>
      <ModalWrapper
        // The role belongs here, not on ModalBackground: that is the
        // click-to-dismiss scrim, and making it the dialog would scope
        // getByRole("dialog") to the overlay rather than the modal content.
        //
        // No aria-modal, matching Panel: nothing traps focus here, so the page
        // behind stays keyboard-reachable and claiming modality would misstate
        // the behaviour.
        role="dialog"
        aria-labelledby={title ? titleId : undefined}
        style={style}
        data-test={dataTest}
        onClick={(event) => {
          // Prevent click from bubbling to background and closing modal
          event.stopPropagation();
        }}
      >
        <ModalContent>
          {title && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "8px",
              }}
            >
              <Typography
                id={titleId}
                variant="h3"
                noMargin
                style={{ textAlign: "left" }}
              >
                {title}
              </Typography>
              <ModalDismiss type="button" aria-label="Close" onClick={dismiss}>
                <DismissIcon icon={faClose} />
              </ModalDismiss>
            </div>
          )}
          {children}
        </ModalContent>
      </ModalWrapper>
    </ModalBackground>
  );
};

export default Modal;
